export const QUICK_REPLY_MAX_CHARACTER_LENGTH = 20;
export const QUICK_REPLY_MAX_TAG_SIZE = 4;
export const QUICK_REPLY_INPUT_HEIGHT = 75;
